import React from 'react';
import { IConfig } from '../../../Interfaces/IConfig';
import { ILegalTransactionFullObject } from '../../../Interfaces/ILegalTransaction';
import { IDocument } from '../../../Interfaces/IDocument';
import { Box, Typography, useMediaQuery } from '@mui/material';
import { DocumentOverview } from '../Document/DocumentOverview';
import { DocumentOverviewMobile } from '../Document/DocumentOverviewMobile';
import { InvoiceDesktop } from './InvoiceDesktop';
import { InvoiceMobile } from './InvoiceMobile';

interface IProps {
  configObject: IConfig;
  legalTransactionObject: ILegalTransactionFullObject;
  handleClose?: () => void;
}

export const InvoiceTab: React.FC<IProps> = ({
  configObject,
  legalTransactionObject,
  handleClose,
}) => {
  const isDesktop = useMediaQuery('(min-width:600px)');

  if (isDesktop) {
    return (
      <>
        <InvoiceDesktop
          configObject={configObject}
          legalTransactionObject={legalTransactionObject}
          handleClose={handleClose}
        />
        <Box sx={{ mb: 5 }} />
        <DocumentOverview
          key={`DocumentOverview-InvoiceArray`}
          configObject={configObject}
          legalTransactionObject={legalTransactionObject}
          idLegalRequirement={legalTransactionObject.idLegalTransaction}
          documentArray={legalTransactionObject.InvoiceArray}
          setDocumentArray={() => {}}
          allowRemove={false}
          allowUpload={false}
          title='Rechnungen'
          showReadPermission={false}
          handleClose={handleClose}
        />
      </>
    );
  } else {
    return (
      <>
        <Typography variant='h5'>Rechnungen</Typography>

        {legalTransactionObject.InvoiceObjectArray.map(invObj => (
          <InvoiceMobile
            key={`mobile-invoice-${invObj.idInvoice}`}
            configObject={configObject}
            invoice={invObj}
            legalTransactionObject={legalTransactionObject}
          />
        ))}

        <DocumentOverviewMobile
          key={`DocumentOverview-InvoiceArray`}
          configObject={configObject}
          legalTransactionObject={legalTransactionObject}
          documentArray={legalTransactionObject.InvoiceArray}
          handleClose={handleClose}
        />
      </>
    );
  }
};
